exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".complexity-box-container[data-v-1f369de7]{margin:5px 0 10px 0;display:-webkit-box;display:-ms-flexbox;display:flex}.complexity-box-container .complexity-box[data-v-1f369de7]{-ms-flex-item-align:center;align-self:center;margin-right:5px;width:20px;height:5px;border-radius:2px}", ""]);

// exports
